import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLineSignature = ({
  className,
  children,
  ...props
}: ComponentProps<'span'>) => {
  return (
    <span
      className={cn(
        'ml-auto text-xs font-bold text-muted-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};

export { TimeLineSignature };
